import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './App.css';

function App() {
  const [capabilities, setCapabilities] = useState([]);
  const [region, setRegion] = useState('');
  const [serverOptions, setServerOptions] = useState([]);
  const [serverName, setServerName] = useState('');
  const [filteredServers, setFilteredServers] = useState([]);
  const [characterName, setCharacterName] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [isDivorceLinkVisible, setDivorceLinkVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetch('https://api.wowchievement.com/capabilities')
      .then((res) => res.json())
      .then((data) => {
        setCapabilities(data.servers);
        const uniqueRegions = Array.from(new Set(data.servers.map(server => server.Region)));
        setServerOptions(uniqueRegions);
      })
      .catch((error) => console.error('Error fetching capabilities:', error));
  }, []);

  useEffect(() => {
    setFilteredServers(
      capabilities
        .filter(server => server.Region === region && server.Slug.toLowerCase().includes(serverName.toLowerCase()))
        .slice(0, 5)
    );
  }, [region, serverName, capabilities]);

  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    if (pathParts.length === 3) {
      const [urlRegion, urlServerName, urlCharacterName] = pathParts;
      setRegion(urlRegion);
      setServerName(urlServerName);
      setCharacterName(urlCharacterName);
      fetchSpecialtyData(urlRegion, urlServerName, urlCharacterName);
    }
  }, [location.pathname]);

  const fetchSpecialtyData = (region, serverName, characterName) => {
    const formattedServerName = serverName.replace(/\s+/g, '-');
    const apiEndpoint = `https://api.wowchievement.com/specialties/${region}?character=${formattedServerName},${characterName}&lang=en_GB`;

    fetch(apiEndpoint)
      .then((res) => {
        if (res.status === 404) {
          console.log("Character not found (404)");
          setResponseMessage("Character not found. Please check the server and character name.");
          setDivorceLinkVisible(false);
          return null;
        } else if (!res.ok) {
          console.error("Error fetching specialties:", res.status);
          setResponseMessage("Character not found, is your husband imaginary?");
          setDivorceLinkVisible(false);
          return null;
        }
        return res.json();
      })
      .then((data) => {
        if (data) {
          const message = data.owned
            ? "Sorry, your husband did splurge those 90 bucks and buy Bruto."
            : "You're safe, your husband didn't buy Bruto. (Yet)";
          setResponseMessage(message);
          setDivorceLinkVisible(data.owned);
        }
      })
      .catch((error) => console.error('Error fetching specialties:', error));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(`/${region}/${serverName}/${characterName}`);
    fetchSpecialtyData(region, serverName, characterName);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1 style={{ color: '#ff69b4' }}>Did my husband buy Bruto?</h1>

        <form onSubmit={handleSubmit} style={{ color: '#ff69b4', fontSize: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <label style={{ marginBottom: '10px' }}>
            Region:
            <select
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              style={{ backgroundColor: '#ffb6c1', color: '#333', margin: '10px', fontSize: '18px' }}
            >
              <option value="">Choose a region</option>
              {serverOptions.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>

          <label style={{ marginBottom: '10px' }}>
            Realm:
            <input
              type="text"
              list="server-suggestions"
              value={serverName}
              onChange={(e) => setServerName(e.target.value)}
              placeholder="Type to search..."
              style={{ backgroundColor: '#ffb6c1', color: '#333', margin: '10px', fontSize: '18px' }}
              disabled={!region}
            />
            <datalist id="server-suggestions">
              {filteredServers.map((server, index) => (
                <option key={index} value={server.Slug} />
              ))}
            </datalist>
          </label>

          <label style={{ marginBottom: '10px' }}>
            Character:
            <input
              type="text"
              value={characterName}
              onChange={(e) => setCharacterName(e.target.value)}
              placeholder="Enter character name"
              style={{ backgroundColor: '#ffb6c1', color: '#333', margin: '10px', fontSize: '18px' }}
            />
          </label>

          <button
            type="submit"
            style={{
              backgroundColor: '#ff69b4',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '5px',
              fontSize: '18px',
              marginTop: '10px'
            }}
          >
            Submit
          </button>
        </form>

        {responseMessage && (
          <div style={{ marginTop: '5px', color: '#ff1493' }}>
            <p style={{ fontSize: '20px' }}>{responseMessage}</p>
            {isDivorceLinkVisible && (
              <a href="https://www.google.com/search?q=nearest+divorce+lawyer" target="_blank" rel="noopener noreferrer" style={{ color: '#ff69b4', textDecoration: 'underline', marginTop: '5px' }}>
                Find a divorce lawyer
              </a>
            )}
            <p style={{ marginTop: '30px', color: '#ff69b4', fontSize: '18px' }}>
              You want to know how much he spent on wow. That's what our spentonwow  <a
                href={`https://spentonwow.com/en/dashboard?region=${region}&server=${serverName.toLowerCase()}&character=${characterName}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff69b4', textDecoration: 'underline' }}
              >
                spentonwow.com
              </a> site is for.
            </p>
            <p style={{ marginTop: '100px', color: '#ff69b4', fontSize: '18px' }}>
              Check out our other tool <a
                href={`https://wowchievement.com/tracker/legion-remix?region=${region}&server[]=${serverName}&character[]=${characterName}&lang=en`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff69b4', textDecoration: 'underline' }}
              >
                wowchievement.com
              </a> you'll be able to track your 20th anniversary collection and activities
            </p>
          </div>
        )}

        <div style={{ marginTop: '150px', color: '#ff1493', fontSize: '14px', textAlign: 'center' }}>
          <p>We're not liable for any divorce papers served due to this website.</p>
          <p>Do not use this website in any way, shape or form to harass or insult other players. At the end it's just a game.</p>
        </div>
        <div style={{ marginTop: '10px', color: '#ff1493', fontSize: '14px', textAlign: 'center' }}>
          <p>If you want more usefull wow tools join our <a
            href={`https://discord.gg/us4ySEdA2w`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#ff1493', textDecoration: 'underline' }}
          >
            Discord server
          </a>.</p>
        </div>
      </header>
    </div>
  );
}

export default App;